import queryString from 'query-string';
import { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { countryName } from 'common/helpers/addresses';
import { listWineCountryCodes } from 'redux/productFilters/actions';

class WineCountryCodeFilter extends Component {
  constructor(props) {
    super(props);
    const { location } = this.props;
    const queryObj = queryString.parse(location.search);
    this.state = {
      wineCountryCode: queryObj.wineCountryCode
    };
  }

  componentDidMount() {
    this.listWineCountryCodes();
  }

  componentDidUpdate(prevProps) {
    const { props } = this;
    if (prevProps.match.params.slug !== props.match.params.slug) {
      this.listWineCountryCodes();
    }
  }

  listWineCountryCodes = () => {
    const { props } = this;
    const { slug } = props.match.params;
    props.listWineCountryCodes(slug);
  };

  handleChange = (e) => {
    const wineCountryCode = e.target.value;
    this.setState({ wineCountryCode });
    this.handleQueryChange(wineCountryCode);
  };

  handleQueryChange = (wineCountryCode) => {
    const { location, history } = this.props;
    const parsed = queryString.parse(location.search);
    if (wineCountryCode === '') {
      delete parsed.wineCountryCode;
    } else {
      parsed.wineCountryCode = wineCountryCode;
    }
    delete parsed.page;
    const stringified = queryString.stringify(parsed);
    let url = location.pathname;
    if (stringified.length > 0) {
      url += `?${stringified}`;
    }
    history.push(url);
  };

  render() {
    const { wineCountryCodes } = this.props;
    const { wineCountryCode } = this.state;
    if (wineCountryCodes.length === 0) {
      return null;
    }
    return (
      <>
        <div className="c7-selectbox">
          <label htmlFor="wineCountryCode">
            Country:
            <span className="c7-selectboxWrap">
              <select
                id="wineCountryCode"
                name="wineCountryCode"
                value={wineCountryCode}
                onChange={this.handleChange}
              >
                <option value="" />
                {wineCountryCodes.map((wt) => (
                  <option value={wt.wineCountryCode} key={wt.wineCountryCode}>
                    {countryName(wt.wineCountryCode)}
                  </option>
                ))}
              </select>
            </span>
          </label>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  wineCountryCodes: state.productFilter.wineCountryCodes
});

export default withRouter(
  connect(mapStateToProps, { listWineCountryCodes })(WineCountryCodeFilter)
);
